module.exports = __webpack_public_path__ + "static/img/exhibitFormTips1.f0b280d4.png";